import React from 'react';

const Banner = ({ id, imgSrc, text, backgroundColor, textAlign }) => {

    const imgStyle = {
        margin: '0 18px',
    };

    if (id === 'facing-threats') {
        return (
            <h3>
                <img src={imgSrc} alt="" aria-hidden="true" style={imgStyle} />
                <span>{text}</span>
            </h3>
        );
    }

    else {
        return (
            <h3>
                <img src={imgSrc} alt="" aria-hidden="true" style={imgStyle} />
                <span>{text}</span>
            </h3>
        );
    };



};

export default Banner;